export enum JobSource {

    JobGate = 1,
    Broadbean = 2,
    ZipRecruiter = 3,
    AdView = 4,
    Internal = 5,
    CvLibrary = 6,
    FmCv = 7,
    External = 8,
    Idibu = 9,
    LogicMelon = 10,
    Recruitive = 11,
    Wavetracker = 12,
    YouRecruit = 13,
    Barchester = 14,
    Appcast = 15,
    CvLibraryPriority = 16,
    AppCastPaid = 17,
    AppcastPriority = 18,
    ZipRecruiterEnt = 19,
    ZipRecruiterJB = 20,
}